import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/priceDiscountGroupsToPriceDiscountLevels'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  priceDiscountGroupToPriceDiscountLevel: {},
  priceDiscountGroupsToPriceDiscountLevels: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  priceDiscountGroupToPriceDiscountLevel: state => state.priceDiscountGroupToPriceDiscountLevel,
  priceDiscountGroupsToPriceDiscountLevels: state => state.priceDiscountGroupsToPriceDiscountLevels
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'REQUEST_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'
const RECEIVE_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'RECEIVE_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'

const REQUEST_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'REQUEST_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'
const RECEIVE_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'RECEIVE_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'

const REQUEST_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'REQUEST_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'
const RECEIVE_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'RECEIVE_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'

const REQUEST_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'REQUEST_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'
const RECEIVE_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL = 'RECEIVE_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL'

const UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL_PROPERTY = 'UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL_PROPERTY'

const REQUEST_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS = 'REQUEST_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS'
const RECEIVE_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS = 'RECEIVE_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getPriceDiscountGroupsToPriceDiscountLevels ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting priceDiscountGroupsToPriceDiscountLevels', { root: true })
    commit(REQUEST_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receivePriceDiscountGroupsToPriceDiscountLevels', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting priceDiscountGroupsToPriceDiscountLevels', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting priceDiscountGroupsToPriceDiscountLevels', { root: true })
        return Promise.reject(error)
      })
  },
  async getPriceDiscountGroupToPriceDiscountLevel ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting priceDiscountGroupToPriceDiscountLevel', { root: true })
    commit(REQUEST_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receivePriceDiscountGroupToPriceDiscountLevel', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.reject(error)
      })
  },
  async createPriceDiscountGroupToPriceDiscountLevel ({ commit, dispatch }, { data, includes = undefined }) {
    dispatch('wait/start', 'creating priceDiscountGroupToPriceDiscountLevel', { root: true })
    commit(REQUEST_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL, data)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.post(`${endpointConfig.url}`, data, config)
      .then((response) => {
        dispatch('receivePriceDiscountGroupToPriceDiscountLevel', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.reject(error)
      })
  },
  async updatePriceDiscountGroupToPriceDiscountLevel ({ commit, dispatch }, { id, data, includes = undefined }) {
    dispatch('wait/start', 'updating priceDiscountGroupToPriceDiscountLevel', { root: true })
    commit(REQUEST_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.put(`${endpointConfig.url}/${id}`, data, config)
      .then((response) => {
        dispatch('receivePriceDiscountGroupToPriceDiscountLevel', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.reject(error)
      })
  },
  async deletePriceDiscountGroupToPriceDiscountLevel ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting priceDiscountGroupToPriceDiscountLevel', { root: true })
    commit(REQUEST_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL, response.data)
        dispatch('wait/end', 'deleting priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting priceDiscountGroupToPriceDiscountLevel', { root: true })
        return Promise.reject(error)
      })
  },
  receivePriceDiscountGroupToPriceDiscountLevel ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL`, extract(json))
    return json.data
  },
  receivePriceDiscountGroupsToPriceDiscountLevels ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS`, extract(json))
    return json.data
  },
  updatePriceDiscountGroupToPriceDiscountLevelProperty ({ commit }, [ property, value ]) {
    commit(`UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, id) {
  },
  [RECEIVE_GET_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, json) {
    state.priceDiscountGroupToPriceDiscountLevel = json
  },
  [REQUEST_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, json) {
  },
  [RECEIVE_CREATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, json) {
    state.priceDiscountGroupToPriceDiscountLevel = json
  },
  [REQUEST_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, id) {
  },
  [RECEIVE_UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, json) {
    state.priceDiscountGroupToPriceDiscountLevel = json
  },
  [REQUEST_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, id) {
  },
  [RECEIVE_DELETE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL] (state, json) {
    state.priceDiscountGroupToPriceDiscountLevel = {}
  },
  [UPDATE_PRICE_DISCOUNT_GROUP_TO_PRICE_DISCOUNT_LEVEL_PROPERTY] (state, [ property, value ]) {
    state.priceDiscountGroupToPriceDiscountLevel[property] = value
  },
  [REQUEST_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS] (state) {
  },
  [RECEIVE_GET_PRICE_DISCOUNT_GROUPS_TO_PRICE_DISCOUNT_LEVELS] (state, json) {
    state.priceDiscountGroupsToPriceDiscountLevels = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
